class AppleAuthService {
  // Check if Apple Sign-In is available
  static isAppleSignInAvailable() {
    console.log('Checking Apple Sign-In availability...');

    // More robust check for Apple Sign-In availability
    const isAvailable = typeof window !== 'undefined' &&
           window.AppleID &&
           window.AppleID.auth &&
           typeof window.AppleID.auth.signIn === 'function';

    console.log('Apple Sign-In available:', isAvailable);
    return isAvailable;
  }

  // Initialize Apple Sign-In
  static async initializeAppleSignIn() {
    if (!this.isAppleSignInAvailable()) {
      throw new Error('Apple Sign-In is not available on this browser');
    }

    try {
      // Validate required environment variables
      const clientId = import.meta.env.VITE_APPLE_CLIENT_ID;
      const redirectURI = import.meta.env.VITE_APPLE_REDIRECT_URI;

      if (!clientId || !redirectURI) {
        throw new Error('Missing required Apple Sign-In configuration. Please check VITE_APPLE_CLIENT_ID and VITE_APPLE_REDIRECT_URI environment variables.');
      }

      console.log('Initializing Apple Sign-In with:', {
        clientId,
        redirectURI,
        origin: window.location.origin
      });

      // Initialize Apple ID with validated configuration
      window.AppleID.auth.init({
        clientId,
        scope: 'email name',
        redirectURI,
        state: 'apple-signin',
        usePopup: false, // Use redirect mode for better compatibility
        responseType: 'code',
        responseMode: 'form_post'
      });
    } catch (error) {
      console.error('Failed to initialize Apple Sign-In:', error);
      throw error;
    }
  }

  // Sign in with Apple using Apple's JavaScript SDK
  static async signInWithApple() {
    console.log('Apple signInWithApple called');
    try {
      // Initialize if not already done
      await this.initializeAppleSignIn();

      // Create a promise to handle the Apple Sign-In response with proper error handling
      return new Promise((resolve, reject) => {
        const signInPromise = window.AppleID.auth.signIn();

        if (!signInPromise || typeof signInPromise.then !== 'function') {
          return reject(new Error('Apple Sign-In did not return a valid promise'));
        }

        signInPromise
          .then((response) => {
            if (response && response.authorization) {
              const { code, id_token, user } = response.authorization;
              
              resolve({
                user: {
                  uid: user?.id || id_token?.sub,
                  email: user?.email,
                  displayName: user?.name ? `${user.name.firstName} ${user.name.lastName}` : null,
                  photoURL: null, // Apple doesn't provide profile photos
                  emailVerified: true
                },
                token: id_token,
                code: code
              });
            } else {
              reject(new Error('Apple authentication failed - no authorization data'));
            }
          })
          .catch((error) => {
            console.error('Apple Sign-In error:', error);
            reject(error);
          });
      });
    } catch (error) {
      console.error('Apple sign-in error:', error);
      throw error;
    }
  }
}

export default AppleAuthService;
